// shared-components/content/ContentSection.jsx

import PropTypes from "prop-types";
import { SECTION_WIDTHS } from "../../core/constants/contentTypes";

const widthClasses = {
  [SECTION_WIDTHS.NARROW]: "max-w-2xl sm:max-w-3xl",
  [SECTION_WIDTHS.NORMAL]: "max-w-3xl sm:max-w-4xl lg:max-w-5xl",
  [SECTION_WIDTHS.WIDE]: "max-w-4xl sm:max-w-5xl lg:max-w-7xl",
  [SECTION_WIDTHS.FULL]: "max-w-full",
};

const Section = ({
  children,
  width = SECTION_WIDTHS.NORMAL,
  className = "",
}) => {
  return (
    <section
      className={`mx-auto px-2 py-4 sm:px-4 ${widthClasses[width]} ${className}`}
    >
      {children}
    </section>
  );
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOf(Object.values(SECTION_WIDTHS)),
  className: PropTypes.string,
};

export default Section;
